
const  generateCurrentTimeStamp = () => {
                var newDate = new Date();
                return (1900 + newDate.getYear()).toString() +
                (newDate.getMonth() + 1).toString() +
                newDate.getDate().toString() +
                newDate.getHours().toString() +
                newDate.getMinutes().toString() +
                newDate.getSeconds().toString();
}
            
export default generateCurrentTimeStamp